export default {
  id: 'notesAndSummaries/FOR_PATIENT/v1',
  formSchema: {
    title: 'encounter:widget.notesAndSummaries.forPatient',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.notesAndSummaries.forPatient',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
